<template>
  <main>
    <Header></Header>
    <Water></Water>
    <Map></Map>
  </main>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Dosis');
  @import './styles/main.css';
</style>
